export const RepetitionWeekdays = {
    WORKDAYS: "RepetitionWeekdays.WORKDAYS",
    ALL: "RepetitionWeekdays.ALL"
};
